export const LocationTypeEnum = Object.freeze({
  REMOTE: "Remote",
  IN_PERSON: "In Person",
});
